import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

import { Config } from "src/app/config";
import { EventsHubService, EDITORMESSAGETYPE, PAGEPROPERTY } from "src/app/services/eventshub.service";
import { ExamService } from "src/app/services/exam.service";
import { ModalDialogService } from "src/app/modals/modaldialog/modaldialog.service";
import { Exam } from "src/app/models/exam";
import { Page } from "src/app/models/page";
import { PageObject } from "src/app/models/pageobject";
import { ObjectProperty } from "src/app/models/objectproperty";

@Component({
  selector: "hkt-objectsproperties",
  templateUrl: "./objectsproperties.component.html",
  styleUrls: ["./objectsproperties.component.scss"],
})
export class ObjectsPropertiesComponent implements OnInit, OnDestroy {
  exam: Exam;
  examSubscription: Subscription;
  eventsHubSubscription: Subscription;
  currentPage: Page;
  currentObject: PageObject;

  constructor(
    private examService: ExamService,
    private eventsHubService: EventsHubService,
    private modalDialogService: ModalDialogService,
  ) {}

  ngOnInit() {
    this.exam = this.examService.currentExam;
    this.currentPage = this.exam.pages[this.exam.currentPageIndex];
    this.currentObject = null;

    this.examSubscription = this.examService.onCurrentExamChange.subscribe(exam => {
      this.exam = exam;
      this.currentPage = this.exam.pages[this.exam.currentPageIndex];
      this.currentObject = null;
    });

    this.eventsHubSubscription = this.eventsHubService.onEditorMessage.subscribe(msg => {
      if (msg.type == EDITORMESSAGETYPE.SelectPage) {
        this.currentPage = this.exam.pages[this.exam.currentPageIndex];
        this.currentObject = null;
      } else if (msg.type == EDITORMESSAGETYPE.SelectObject) {
        this.currentObject = msg.data;
      }
    });
  }

  ngOnDestroy() {
    if (this.examSubscription) {
      this.examSubscription.unsubscribe();
      this.examSubscription = null;
    }
    if (this.eventsHubSubscription) {
      this.eventsHubSubscription.unsubscribe();
      this.eventsHubSubscription = null;
    }
  }

  onPageNameChanged(event): void {
    let value = event.target.value.trim();
    if (this.exam.checkPageNameInUse(value, this.exam.currentPageIndex)) {
      event.target.value = this.currentPage.name;
      setTimeout(() => {
        this.modalDialogService.showAlert(Config.APP_NAME, "The name '" + value + "' is already in use");
      }, 0);
    } else {
      // Update menu
      for (let m of this.exam.menu) {
        if (m.pageName === this.currentPage.name) {
          m.pageName = value;
        }
      }
      // Update page name
      this.currentPage.name = value;
    }
  }

  onPageBackgroundChanged(value): void {
    this.currentPage.background = value;
    this.eventsHubService.setPagePropertyChange({
      type: PAGEPROPERTY.Background,
      value: this.currentPage.background,
    });
  }

  onPageIconChanged(value): void {
    this.currentPage.pageIcon = value;
    this.eventsHubService.setPagePropertyChange({
      type: PAGEPROPERTY.Icon,
      value: this.currentPage.pageIcon,
    });
  }

  onPropertyChanged(prop: ObjectProperty, value): void {
    if (this.currentObject == null) {
      return;
    }
    let oldValue = this.currentObject.getPropertyValue(prop.name);
    if (oldValue != value) {
      this.currentObject.setPropertyValue(prop.name, value, this.exam.style);
      if (prop.name == "Position Z") {
        this.currentPage.sortObjects();
      }
    }
  }
}
